import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from './Dashboard';
import AgronomistDashboard from './AgronomistDashboard';
import FieldFacilitatorDashboard from './FieldFacilitatorDashboard';
import OwnerDashboard from './OwnerDashboard';

/**
 * Conditional Dashboard Wrapper
 * Renders the appropriate dashboard based on user role:
 * - Agronomist -> AgronomistDashboard
 * - Field Facilitator -> FieldFacilitatorDashboard
 * - All other roles -> Default Dashboard
 */
const DashboardWrapper: React.FC = () => {
    const { user } = useAuth();

    if (user?.role === 'super_admin') {
        return <Navigate to="/dashboard/super-admin" replace />;
    }

    if (user?.role === 'agronomist') {
        return <AgronomistDashboard />;
    }

    if (user?.role === 'field_facilitator') {
        return <FieldFacilitatorDashboard />;
    }

    if (user?.role === 'owner') {
        return <OwnerDashboard />;
    }

    return <Dashboard />;
};

export default DashboardWrapper;
